import { css } from 'lit';

export const styles = css`:host{--border-color: var(--ig-list-border-color, var(--ig-gray-200));--border-width: var(--ig-list-border-width, 0.0625rem);--ig-theme: fluent}`;
